import { Component } from '@angular/core';

@Component({
  selector: 'app-legal-notice',
  templateUrl: 'legal-notice.component.html',
})
export class LegalNoticeComponent {}
